import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/utils/cn';
import type { VariantProps } from 'class-variance-authority';
import Link from 'next/link';
import type { ComponentProps } from 'react';

export type ButtonVariant = VariantProps<typeof buttonVariants>['variant'];

interface ButtonLinkProps extends Omit<ComponentProps<typeof Link>, 'className'> {
    asChild?: boolean;
    dummy?: boolean;
    variant?: VariantProps<typeof buttonVariants>['variant'];
    size?: VariantProps<typeof buttonVariants>['size'];
    disabled?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export default function ButtonLink({
    asChild = false,
    dummy = false,
    variant,
    size,
    disabled,
    className,
    children,
    ...props
}: ButtonLinkProps) {
    const classes = cn(buttonVariants({ variant, size }), className);

    if (asChild) {
        return <span className={classes}>{children}</span>;
    }

    if (dummy) {
        return <div className={classes}>{children}</div>;
    }

    return (
        <Link {...props} className={classes} aria-disabled={disabled}>
            {children}
        </Link>
    );
}
